import "../../libs/backbone/backbone.ajaxq.adapter.ts";
import GenericView from 'views/generic.view.ts';
import Handlebars from 'handlebars';
import Template from 'text-loader!../templates/settings.template.html';
import i18n from "l10n";
import popup from "popup";

import PrinterBlockView from '../views/settings/printerBlock.view.ts';

export default GenericView.extend({
    el: "#container",
    tagName: 'div',
	template: Handlebars.compile(Template),
	Model : null,
	userData: null,
    numberPrivilegeLevel: null,
	initialize: function (options) {
		var self = this;

		this.userData = options.data;
		this.numberPrivilegeLevel = this.privilegeLevelToNumber(this.userData.privilegeLevel);

        this.render();

        this.loadData();
	},
	superRender: GenericView.prototype.render,
	render: function () {
		var self = this;

		this.superRender();

		this.$el.html(this.template( {privilegeLevel: this.numberPrivilegeLevel}));

		return this;
	},
	events:{
		"click #reloadQueueMonitors": "reloadQueueMonitors",
	},
	loadData: function() {
	    this.loadPrinterBlock();
	},
	reloadQueueMonitors: function(event) {
        var self = this;

        var element = $(event.currentTarget);

        var params = {
            "url": "rest/api/admin/settings/reloadQueueMonitors",
            "type": "POST",
            "data": null,
            "successMessage": i18n.t("settings.queueMonitors.reloaded"),
            "errorMessage": i18n.t("settings.queueMonitors.notReloaded"),
            "_cancelBtn": $('#cancelBtn'),
            "_actionButton": $('#reloadQueueMonitors'),
        }

        popup.show(i18n.t("pageHeader.confirm_action"), i18n.t("settings.queueMonitors.reloadMessage"), "confirm_action", params );
    },
    loadPrinterBlock: function() {
        var printerBlockView = new PrinterBlockView();
        this.$el.find("#printerBlock").html( printerBlockView.render().el );

        printerBlockView.loadData();
    }
});

